// import React, { useEffect, useRef, useState } from 'react';
// import { Line } from 'react-konva';
// import { useTransformer } from './TransformerContext';

// const Freehand = ({
//   id,
//   isSelected,
//   onSelect,
//   draggable = true,
//   stroke = '#1890ff',
//   strokeWidth = 2,
//   initialPoints = [], // array of [x1, y1, x2, y2, ..., xn, yn]
//   ...props
// }) => {
//   const lineRef = useRef(null);
//   const transformerRef = useTransformer();
//   const [points, setPoints] = useState(initialPoints);

//   // Attach transformer if selected
//   useEffect(() => {
//     if (isSelected && transformerRef.current && lineRef.current) {
//       transformerRef.current.nodes([lineRef.current]);
//       transformerRef.current.getLayer().batchDraw();
//     }
//   }, [isSelected]);

//   return (
//     <Line
//       id={id}
//       ref={lineRef}
//       points={points}
//       stroke={stroke}
//       strokeWidth={strokeWidth}
//       tension={0.5}
//       lineCap="round"
//       lineJoin="round"
//       draggable={draggable}
//       onClick={onSelect}
//       onTap={onSelect}
//       onDragEnd={(e) => {
//         const { x, y } = e.target.position();
//         // Update all points relative to new position
//         const newPoints = [];
//         for (let i = 0; i < points.length; i += 2) {
//           newPoints.push(points[i] + x, points[i + 1] + y);
//         }
//         e.target.position({ x: 0, y: 0 }); // reset position (we moved points)
//         setPoints(newPoints);
//       }}
//     />
//   );
// };

// export default Freehand;


import React, { useEffect, useRef, useState } from 'react';
import { Line, Group } from 'react-konva';
import { useTransformer } from './TransformerContext';
import LayerListeners from './LayerListeners';

const Freehand = ({
  id,
  isSelected,
  onSelect,
  stroke = '#1890ff',
  strokeWidth = 2,
  initialPoints = [],
  onComplete = () => { },
  ...props
}) => {
  const lineRef = useRef(null);
  const transformerRef = useTransformer();
  // Attach transformer if selected
  useEffect(() => {
    if (isSelected && transformerRef.current && lineRef.current) {
      transformerRef.current.nodes([lineRef.current]);
      transformerRef.current.getLayer().batchDraw();
    }
  }, [isSelected]);

  return (
    <Line
      id={id}
      ref={lineRef}
      points={initialPoints}
      stroke={stroke}
      strokeWidth={strokeWidth}
      tension={0.5}
      lineCap="round"
      lineJoin="round"
      draggable={false} // don't drag while drawing
      onClick={onSelect}
      onTap={onSelect}
      {...props}
      hitStrokeWidth={20}
    />
  );
};

export default Freehand;

